<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <h1 class="gradient-text">Financeiro</h1>
      <p>{{ 'auth.reset_password_subtitle' | translate }}</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'settings.new_password' | translate }}</mat-label>
        <input
          matInput
          formControlName="novaSenha"
          [type]="hidePassword ? 'password' : 'text'"
          autocomplete="new-password"
        />
        <mat-icon matPrefix>lock</mat-icon>
        <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="form.get('novaSenha')?.hasError('required')">
          {{ 'auth.password_required' | translate }}
        </mat-error>
        <mat-error *ngIf="form.get('novaSenha')?.hasError('minlength')">
          {{ 'auth.password_min' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'settings.confirm_password' | translate }}</mat-label>
        <input
          matInput
          formControlName="confirmarSenha"
          [type]="hideConfirm ? 'password' : 'text'"
          autocomplete="new-password"
        />
        <mat-icon matPrefix>lock</mat-icon>
        <button mat-icon-button matSuffix type="button" (click)="hideConfirm = !hideConfirm">
          <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="form.get('confirmarSenha')?.hasError('required')">
          {{ 'auth.password_required' | translate }}
        </mat-error>
      </mat-form-field>

      <button
        mat-raised-button
        class="login-button full-width"
        type="submit"
        [disabled]="form.invalid || loading"
      >
        <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
        <span *ngIf="!loading">{{ 'auth.reset_password' | translate }}</span>
      </button>
    </form>

    <div class="login-footer">
      <a routerLink="/login">{{ 'common.back' | translate }}</a>
    </div>
  </div>
</div>
